(function () {
    document.addEventListener('DOMContentLoaded', function () {

        const suscriptionCTA = document.getElementById('culto-sub-cta');
        // En la PDP de un café con plan vinculado, los selectores del plan viven dentro
        // del panel "Suscribite y ahorrá": se leen desde ahí para no confundirlos con
        // los selectores propios del café.
        const subscribeAndSave = suscriptionCTA?.closest('[data-subscribe-and-save]');
        const scope = subscribeAndSave || document;

        function getCheckedValue(name) {
            return $(scope).find(`input[name="${name}"]:checked`).val();
        }

        function getPriceId(targetVariant) {
            const bags = parseInt(targetVariant.option2, 10);
            const planName = productTitle.toLowerCase().replace('plano', '').replace('plan', '').trim();
            return `price-culto-${planName}-${bags}`;
        }

        function getCheckoutUrl(variantsValues) {
            const targetVariant = variantsData.find(v => v.option1 === variantsValues[0] && v.option2 === variantsValues[1]);
            const priceId = getPriceId(targetVariant);
            var baseUrl = countryCode === 'br' ? 'https://cafeculto.com.br' : 'https://cultocafe.uy';
            var checkoutBaseUrl = countryCode === 'br' ? 'https://checkout.cafeculto.com.br' : 'https://checkout.cultocafe.uy';
            let checkoutUrl = `${checkoutBaseUrl}?product_id=${productId}&variant_id=${targetVariant.id}&price_id=${priceId}`;
            if (typeof checkoutFlowProduct !== 'undefined' && checkoutFlowProduct) {
                checkoutUrl += `&flow=producto-${checkoutFlowProduct}`;
            }
            // Marca que la suscripción salió de "Suscribite y ahorrá" en la PDP de un
            // café (flow=producto-<handle> es ese café), para distinguirla de la PDP
            // de un plan en las métricas de conversión.
            if (subscribeAndSave) {
                checkoutUrl += '&entry=subscribe-and-save';
            }
            // Optionally add promo_name from current URL
            const urlParams = new URLSearchParams(window.location.search);
            const promoNameParam = urlParams.get('promo_name');
            if (promoNameParam) {
                checkoutUrl += `&promo_name=${encodeURIComponent(promoNameParam)}`;
            }
            const starterPack = getCheckedValue('StarterPack');
            if (starterPack) {
                checkoutUrl += `&starter_pack_item=${encodeURIComponent(starterPack)}`;
            }
            sessionStorage.setItem('culto_checkout_url', checkoutUrl);

            if (window.hasActiveSubscription) {
                checkoutUrl = `${baseUrl}/account`;
            }
            return checkoutUrl;
        }

        suscriptionCTA?.parentElement?.addEventListener('click', function(e) {
            e.preventDefault();
            let $molienda = getCheckedValue('Molienda');
            let $cantidad = getCheckedValue('Cantidad');

            const variantValues = [$molienda,$cantidad];

            if (!window.subscriptionCheckComplete) {
                var btn = suscriptionCTA;
                var originalText = btn.textContent;
                btn.textContent = 'Cargando...';
                var attempts = 0;
                var waitInterval = setInterval(function() {
                    attempts++;
                    if (window.subscriptionCheckComplete || attempts >= 20) {
                        clearInterval(waitInterval);
                        btn.textContent = originalText;
                        window.location.href = getCheckoutUrl(variantValues);
                    }
                }, 100);
            } else {
                window.location.href = getCheckoutUrl(variantValues);
            }
        });

        // --- Suma el precio del starter pack al precio mostrado (solo planes plan-* UY) ---
        (function starterPackPrice() {
            // En "Suscribite y ahorrá" el precio mostrado es el del café, no el del plan.
            if (subscribeAndSave) return;
            const packInputs = document.querySelectorAll('input[name="StarterPack"]');
            const priceWrapper = document.querySelector('.price-wrapper');
            if (!packInputs.length || !priceWrapper) return;

            function selectedVariant() {
                const molienda = $('input[name="Molienda"]:checked').val();
                const cantidad = $('input[name="Cantidad"]:checked').val();
                return variantsData.find(v => v.option1 === molienda && v.option2 === cantidad);
            }

            function surcharge() {
                const checked = document.querySelector('input[name="StarterPack"]:checked');
                return checked ? (parseInt(checked.getAttribute('data-price'), 10) || 0) : 0;
            }

            function render() {
                const variant = selectedVariant();
                if (!variant) return;
                const total = variant.price + surcharge();
                const formatted = (typeof formatMoney === 'function')
                    ? formatMoney(total)
                    : '$' + (total / 100);
                const el = priceWrapper.querySelector('.price__regular .price-item--regular');
                if (el && el.textContent.trim() !== formatted.trim()) {
                    el.textContent = formatted;
                }
            }

            packInputs.forEach(input => input.addEventListener('change', render));
            // El precio se re-renderiza al cambiar la variante (renderProductInfo); re-aplicamos el recargo.
            new MutationObserver(render).observe(priceWrapper, { childList: true, subtree: true });
            render();
        })();
	});
})();